// extracted by mini-css-extract-plugin
export default {"NotFound":"NotFound_NotFound__bXe48"};